module.exports = __webpack_public_path__ + "app-static/img/p_04.97db8ac1.jpg";